var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-full"},[_c('div',{ref:"FamilyChart",staticClass:"f3",attrs:{"id":"FamilyChart"}}),(_vm.selectedPersonInfo)?_c('ModalEditTreeFamily',{ref:"ModalEditTreeFamily",attrs:{"selectedPersonInfo":_vm.selectedPersonInfo}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }